import type { DeepPartial } from '@luna/utils-ts';
import type { CardsFeatureConfig } from '@shared/cards-config';

import {
    CardActivationFeatureConfig,
    CardBankHeaderFeatureConfig,
    CardBlockingFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardLockFeatureConfig,
    CardsBankListFeatureConfig,
    CardsCreditLimitChangeFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    isNativeAliasChangeAllowed: true,
    overview: {
        CREDIT: {
            AUTHORIZED: {
                hide: true,
            },
            displayLimit: true,
        },
        BANK_CARD: {
            MAIN: {
                hide: false,
            },
            AUTHORIZED: {
                hide: true,
            },
        },
        VIRTUAL_DEBIT: {
            MAIN: {
                hide: false,
            },
            AUTHORIZED: {
                hide: false,
            },
            AUTHORIZED_STANDALONE: {
                hide: false,
            },
        },
    },
    bank: {
        showAsProduct: true,
        removeCardAlias: true,
        hasInsurance: true,
        settings: {
            limitChange: false,
        },
        supplementary: {
            enabled: true,
        },
    },
    shared: {
        settings: {
            reissue: {
                pin: {
                    deliveryAddress: {
                        enabled: true,
                        types: ['CREDIT'],
                    },
                },
            },
        },
        functions: {
            tpLimits: {
                permanentAlwaysActive: true,
            },
            lockAndReplace: {
                lockOnly: {
                    BANK_CARD: {
                        enabled: true,
                    },
                },
                lockAndReplace: {
                    CREDIT: {
                        enabled: true,
                    },
                    BANK_CARD: {
                        enabled: true,
                    },
                },
            },
        },
    },
    bank_card: {
        settings: {
            allowPersonalization: true,
            productWhitelist: ['AUTHORIZED_STANDALONE', 'MAIN'],
        },
    },
    credit: CreditSharedFeatureConfig.SK,
    components: {
        limitsChange: CardLimitsChangeFeatureConfig.SK,
        cardsList: CardsBankListFeatureConfig.SK,
        bankCardHeader: CardBankHeaderFeatureConfig.SK,
        cardBlocking: CardBlockingFeatureConfig.SK,
        cardActivation: CardActivationFeatureConfig.SK,
        creditCardLimitChange: CardsCreditLimitChangeFeatureConfig.SK,
        cardLock: CardLockFeatureConfig.SK,
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.SK,
        },
        creditCardContentBox: CreditCardContentBoxFeatureConfig.SK,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.SK,
    },
    statements: {
        signed: true,
        onlyElectronic: true,
        showPhoneNumbersDropdown: false,
        reversibleToPaperDelivery: false,
        deliverySelectable: true,
    },
};
